import React from "react"

import SEO from "../components/seo"
import Header from "../components/header"
import Main from "../components/Main"
import Footer from "../components/Footer"

import 'bootstrap/dist/css/bootstrap.css';

const gb = () => (
  <div className="CartorioGustavoPinto">
    <Header/>
      <SEO title="Cartório Gustavo Pinto" />
      <Main/>
      <Footer/>
    </div>
)

export default gb
